import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, resolving Tailwind conflicts in favour of the last one.
 *
 * `clsx` alone would leave `px-2 px-4` in the output and let CSS source order
 * decide — which breaks the ability to override a component's padding from its
 * call site. `twMerge` makes the later class win, as callers expect.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
